export interface CardData {
  label: string;
  value: string | number | string[] | null | undefined;
  info?: string;
}

export function numberWithCommas(value: number) {
  if (!value) {
    return '-';
  }
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
